export default __webpack_public_path__ + "static/media/portfolio.213d8039.svg";